import { jobsQueries } from '@/api/queryKeys';
import { useQuery } from '@tanstack/react-query';

const useGetJob = (jobId: string | undefined, enabled: boolean = true) => {
  return useQuery({
    ...jobsQueries.detail(jobId ?? ''),
    enabled: !!jobId && enabled,
    refetchInterval: (data) => {
      const completed = data.state.data?.complete;
      if (completed || !enabled) {
        return false;
      }
      return 1500;
    },
  });
};

const useGetJobOnce = (jobId: string | undefined) => {
  return useQuery({
    ...jobsQueries.once(jobId ?? ''),
    enabled: !!jobId,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    staleTime: Infinity,
  });
};

export { useGetJob, useGetJobOnce };
